<template v-once>
  <img src="@/assets/icons/knipper_icon.jpg" alt="knipper icon">
</template>

<script>
export default {
  name: "Knipper",
};
</script>

<style scoped>
</style>